<ng-container *ngIf="(routerState$ | async)?.data as routerStateSnapshot">
  <app-top-sub-nav [title]="routerStateSnapshot.title"> </app-top-sub-nav>

  <router-outlet></router-outlet>
</ng-container>
